"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyle = exports.InstanceFooters = void 0;
// @ts-nocheck
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const react_1 = __importStar(require("react"));
const FormRendererHelpers_1 = require("../../utils/FormRendererHelpers");
const RepeatWrapperWeb_1 = require("./RepeatWrapperWeb");
const theme_1 = require("../../styles/theme");
const common_1 = require("../../utils/common");
const RepeatFieldWrapperWeb = props => {
    const { controlDefinition, onRemoveClick, repeatCount, isOriginal, translateFunction = text => text } = props, moreProps = __rest(props, ["controlDefinition", "onRemoveClick", "repeatCount", "isOriginal", "translateFunction"]);
    const { openDeleteConfirmation } = (0, RepeatWrapperWeb_1.useRepeatWrapperContext)();
    const classes = (0, exports.useStyle)();
    const type = controlDefinition.type;
    const deleteMarginTop = type === 'location' || type === 'floorPlanLocation' ? 20
        : type === 'select' || type === 'checkbox' ? -2
            : type === 'mapAggregateSelector' || type === 'polyline' ? 30
                : type === 'barcode' ? 27 : 0;
    const canDelete = (0, react_1.useCallback)(() => {
        if (isOriginal && !(0, FormRendererHelpers_1.getAllowInitialDataDelete)(controlDefinition)) {
            return false;
        }
        return repeatCount > (0, FormRendererHelpers_1.getRepeatMin)(controlDefinition);
    }, [repeatCount, controlDefinition, isOriginal]);
    return (react_1.default.createElement("div", { style: styles.root },
        react_1.default.createElement("div", { className: classes.fieldWrapper },
            react_1.default.createElement("div", { className: classes.fieldContent }, props.children),
            canDelete() && (react_1.default.createElement(core_1.Button, { size: 'small', style: Object.assign(Object.assign({}, styles.deleteButton), { marginTop: deleteMarginTop }), variant: 'text', onClick: () => {
                    openDeleteConfirmation(onRemoveClick, (0, FormRendererHelpers_1.getDeleteConfirmationMessage)(controlDefinition));
                } }, translateFunction('Delete')))),
        react_1.default.createElement(exports.InstanceFooters, Object.assign({}, props))));
};
const InstanceInfo = ({ label, value }) => (react_1.default.createElement("div", { style: styles.innerStyle },
    react_1.default.createElement("span", { style: styles.labelStyle }, label),
    react_1.default.createElement("span", { style: styles.valueStyle }, `: ${value}`)));
const InstanceFooters = (props) => {
    const { repeatCount, index, controlDefinition, onAddClick, translateFunction = text => text } = props, moreProps = __rest(props, ["repeatCount", "index", "controlDefinition", "onAddClick", "translateFunction"]);
    const classes = (0, exports.useStyle)();
    const canDelete = (0, react_1.useCallback)(() => {
        return repeatCount === index + 1 && (0, FormRendererHelpers_1.getRepeatsEnabled)(controlDefinition);
    }, [repeatCount, index, controlDefinition]);
    const repeatMax = (0, react_1.useMemo)(() => {
        return (0, FormRendererHelpers_1.getRepeatMax)(controlDefinition);
    }, [controlDefinition]);
    const canAddItem = (0, react_1.useCallback)(() => {
        if (!(0, FormRendererHelpers_1.getAllowAdding)(controlDefinition)) {
            return false;
        }
        const repeatMaxSetting = (0, FormRendererHelpers_1.getRepeatMax)(controlDefinition);
        return repeatMaxSetting === -1 || repeatCount < repeatMaxSetting;
    }, [repeatCount, controlDefinition]);
    return canDelete() ? (react_1.default.createElement("div", { style: styles.deleteContainer },
        react_1.default.createElement("div", { className: classes.countContainerStyle },
            react_1.default.createElement(InstanceInfo, { label: translateFunction('Instances'), value: repeatCount }),
            react_1.default.createElement(InstanceInfo, { label: translateFunction('Required'), value: (0, FormRendererHelpers_1.getRepeatMin)(controlDefinition) }),
            react_1.default.createElement(InstanceInfo, { label: translateFunction('Allowed'), value: repeatMax === -1 ? translateFunction('unlimited') : repeatMax })),
        canAddItem() && (react_1.default.createElement(core_1.Button, { size: 'small', onClick: () => {
                onAddClick();
            }, color: 'primary', className: classes.button }, translateFunction((0, FormRendererHelpers_1.getAddButtonText)(controlDefinition)))))) : null;
};
exports.InstanceFooters = InstanceFooters;
exports.useStyle = (0, styles_1.makeStyles)(theme => ({
    fieldWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        borderBottom: `1px solid ${theme_1.colors.black10}`,
        padding: '18px 20px',
        '& > *:first-child': {
            flex: 1,
            minWidth: 0,
        },
        gap: 5,
    },
    fieldContent: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
    },
    repeatDetails: {
        margin: theme.spacing(1),
        display: 'flex',
    },
    repeatMenu: {
        margin: theme.spacing(1),
        display: 'flex',
    },
    instanceInfo: {
        fontWeight: 500,
    },
    handle: {
        display: 'flex',
        width: 25,
        alignItems: 'center',
        '& img': {
            width: 13,
            height: 21,
            marginRight: '.3em',
        },
        '& span': {
            color: theme_1.colors.title,
        },
    },
    button: {
        fontSize: 13,
        fontWeight: 500,
        textTransform: 'capitalize',
    },
    countContainerStyle: {
        display: 'flex',
        fontSize: '13px',
        fontWeight: 400,
        gap: '10px',
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            flexDirection: 'column',
            gap: 6,
        },
    },
}));
const styles = {
    root: {
        flexDirection: 'column',
    },
    deleteButton: {
        color: theme_1.colors.darkRed,
        display: 'flex',
        justifyContent: 'end',
        fontSize: 13,
        fontWeight: 400,
        lineHeight: 'normal',
        textTransform: 'capitalize',
        marginLeft: 5,
        minWidth: 0,
        '&:hover': {
            background: 'none',
        },
    },
    deleteContainer: {
        backgroundColor: theme_1.colors.lotion,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
    },
    countContainer: {
        display: 'flex',
        fontSize: '13px',
        fontWeight: 400,
    },
    labelStyle: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
    },
    valueStyle: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
    },
    innerStyle: {
        display: 'flex',
    },
    seprator: {
        marginRight: 2,
    },
};
exports.default = RepeatFieldWrapperWeb;
//# sourceMappingURL=RepeatFieldWrapperWeb.js.map